import { Modal } from 'antd';
import classNames from 'classnames';
import { FormattedMessage } from 'react-intl';

import { cssVariables } from '../../styles/cssVariables';
import { useSimpleDialogStyles } from './SimpleDialog.styles';

function SimpleDialogIconBase({ className, ...rest }) {
  const { styles } = useSimpleDialogStyles();
  return (
    <div
      className={classNames(
        'SimpleDialog-Icon',
        styles.simpleDialogIcon,
        className
      )}
      {...rest}
    />
  );
}

const SimpleDialogIcon = SimpleDialogIconBase;

export const SimpleDialogMaskStyles = {
  dark: { backgroundColor: `${cssVariables.colorGreyDark2}D9` },
};

export default function SimpleDialog({
  children,
  className,
  title,
  titleId,
  icon,
  iconClassName,
  open = true,
  ...rest
}) {
  const { styles } = useSimpleDialogStyles();

  return (
    <Modal
      className={classNames('SimpleDialog', styles.simpleDialog, className)}
      open={open}
      title={titleId ? <FormattedMessage id={titleId} /> : title}
      closable={false}
      mask={false}
      maskClosable={false}
      footer={null}
      width="auto"
      {...rest}
    >
      {icon && (
        <SimpleDialogIcon className={iconClassName}>{icon}</SimpleDialogIcon>
      )}
      {children}
    </Modal>
  );
}

export function SimpleDialogLabel({ className, ...rest }) {
  const { styles } = useSimpleDialogStyles();
  return (
    <div
      className={classNames(
        'SimpleDialog-Label',
        styles.simpleDialogLabel,
        className
      )}
      {...rest}
    />
  );
}
